var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHashtagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1FB4F293-AF77-4099-BC30-3384FE661D42") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BBFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CDFE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup---Enabled",
    transform: "translate(-1121.000000, -360.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hashtag-(Quest)",
    transform: "translate(893.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hashtag-Icon",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7655514,-2.13162821e-14 L26.7655514,9.90292071 L13.2361152,9.90292071 L13.2361152,-2.13162821e-14 L9.90292071,-2.13162821e-14 L9.90292071,9.90292071 L0,9.90292071 L0,13.2361152 L9.90292071,13.2361152 L9.90292071,26.7655514 L0,26.7655514 L0,30.0970793 L9.90292071,30.0970793 L9.90292071,39.9983334 L13.2361152,39.9983334 L13.2361152,30.0970793 L26.7655514,30.0970793 L26.7655514,39.9983334 L30.0987459,39.9983334 L30.0987459,30.0970793 L40,30.0970793 L40,26.7655514 L30.0987459,26.7655514 L30.0987459,13.2361152 L40,13.2361152 L40,9.90292071 L30.0987459,9.90292071 L30.0987459,-2.13162821e-14 L26.7655514,-2.13162821e-14 Z M13.2361152,26.7655514 L26.7655514,26.7655514 L26.7655514,13.2361152 L13.2361152,13.2361152 L13.2361152,26.7655514 Z",
    id: "Fill-1-Copy-2"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagIcon);
export default __webpack_public_path__ + "static/media/hashtag-icon.bbcb744e.svg";
export { ForwardRef as ReactComponent };